import styled from "styled-components";

export const Item =  styled.div`
  display: flexbox;
  align-content: center;
  align-items: center;
  justify-content: center;
  align-self: center;
  height: 8rem;
  width: 100%;
  color: #fff;
  margin: 15px;
`;
